import { render, staticRenderFns } from "./DocumentosSubidosComponent.vue?vue&type=template&id=7302b7c1"
import script from "./DocumentosSubidosComponent.vue?vue&type=script&lang=js"
export * from "./DocumentosSubidosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports